import React, { Fragment, useState } from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import { HiChevronUpDown } from 'react-icons/hi2'
import { Listbox, Transition } from '@headlessui/react'
import Countries from '../Json/Countries.json'
import Industry from '../Json/Industry.json'
import { FiChevronDown } from "react-icons/fi"

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const BusinessDetails = ({setStep, setMainStep, businessDetail, setBusinessDetail, isUpdate, setData }) => {
    const [openId, setOpenId] = useState([])
    const [validName, setValidName] = useState('')

    const handleIsopen = (i) => {
        setOpenId((prev) => {
            if (prev.includes(i)) {
                return prev.filter((val) => val !== i)
            } else {
                return [...openId, i]
            }
        })
    }

    const handleContinue = () => {
        if (!validation()) {
            if(isUpdate){
                setMainStep('step5');
                setStep('Summary');
                setData('default')
            } else {
                setStep('representative')
            } 
        }
    }

    const validation = () => {
        let valid = false;
        if (businessDetail.business_name === "") {
            setValidName("Please enter a legal business name.");
            valid = true;
        }
        return valid;
    };

    return (
        <div>
            <div>
                <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[36px]'>Tell us more about your business</h3>
                <p className='text-[#414552] mt-2'>Stripe collects this information to better serve your business and help meet the requirements of regulators, financial partners, and our <span className='font-semibold text-[#625afa]'>Services Agreement.</span></p>
                <div className='sm:mt-[40px] mt-[20px]'>
                    <div>
                        <label htmlFor="Legal-business-name" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Legal business name</label>
                        <div className="relative mt-1 w-full">
                            <input
                                value={businessDetail.business_name}
                                onChange={(e) => setBusinessDetail({...businessDetail, business_name: e.target.value})}
                                type='text' id="Legal-business-name" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Company' />
                        </div>
                        <p className='text-sm text-[#414552] mt-2'>The name you provide must exactly match the name associated with your tax ID.</p>
                        <p className="text-red-600">{businessDetail.business_name === "" ? validName : ""}</p>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Employer identification Number (EIN)</label>
                        <div className="flex gap-3 items-center mt-2">
                            <span className='text-sm text-[#687385] font-medium'>Provided</span>
                            <button className='input_focus_shadow rounded-md flex items-center gap-1 font-semibold w-max h-[36px] px-2 justify-center text-[#101b25]'>Replace</button>
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <p className='text-sm text-[#414552]'>If you use your Social Security Number for business tax purposes, you can enter that instead.</p>
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <div className='flex gap-2 items-center'>
                            <label htmlFor="do-business" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Doing business as</label>
                            <div className="p-[1px_6px] rounded-md h-fit text-[#545969] flex items-center justify-center bg-[#ebeef1] text-xs font-semibold">Optional</div>
                        </div>
                        <div className="relative mt-1 w-full">
                            <input
                                value={businessDetail.doing_business_as}
                                onChange={(e) => setBusinessDetail({...businessDetail, doing_business_as: e.target.value})}
                                type='text' id="do-business" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" />
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <p className='text-sm text-[#414552]'>The operating name of your company if it's different than the legal name.</p>
                        </div>
                    </div>

                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label htmlFor="Registered-business" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Registered business address</label>
                        <div>
                            <div className="relative w-full mt-1">
                                <select disabled value={businessDetail.business_country} id="country" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                    {Countries.slice(1).map((val, i) =>
                                        <option key={i} value={val.country}>{val.country}</option>
                                    )}
                                </select>
                                <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[25px]" />
                            </div>
                            <div className='mt-5'>
                                <input
                                    value={businessDetail.business_address1}
                                    onChange={(e) => setBusinessDetail({...businessDetail, business_address1: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Address-line1' />
                                <input
                                    value={businessDetail.business_address2}
                                    onChange={(e) => setBusinessDetail({...businessDetail, business_address2: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Address-line2' />
                                <input
                                    value={businessDetail.business_city}
                                    onChange={(e) => setBusinessDetail({...businessDetail, business_city: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='City' />
                                <input
                                    value={businessDetail.zip}
                                    onChange={(e) => setBusinessDetail({...businessDetail, zip: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Zip' />
                                <div className="relative w-full mt-2">
                                    <select value={businessDetail.business_state} onChange={(e) => setBusinessDetail({...businessDetail, business_state: e.target.value})} id="state" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                        {Countries.map((val) =>
                                            businessDetail.business_country === val.country &&
                                            val.states.map((state, i) => <option key={i} value={state} > {state}</option>)
                                        )}
                                    </select>
                                    <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[25px]" />
                                </div>
                            </div>
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <p className='text-sm text-[#414552]'>You can use your home address if you don't have a business address.</p>
                        </div>
                    </div>

                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Business phone number</label>
                        <div className="rounded-[6px] mt-1 w-full flex items-center relative">
                            <div className='text-sm pl-2 text-[#414552] absolute top-[50%] translate-y-[-50%] left-1'>+1</div>
                            <input
                                value={businessDetail.business_phone_number}
                                onChange={(e) => setBusinessDetail({...businessDetail, business_phone_number: e.target.value})}
                                type='number' placeholder='(201) 555-0123' id="Company-identification" className="input_focus_shadow text-[#404452] rounded-[6px] pr-3 pl-9 w-full bg-white font-normal focus:outline-none h-[36px] py-1 text-[14px]" />
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <p className='text-sm text-[#414552]'>Please provide a phone number where customers can contact your business. This number must be displayed on your website's 'Contact us' page.</p>
                        </div>
                    </div>

                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Industry</label>
                        <Listbox value={businessDetail.industry} onChange={(value) => setBusinessDetail({ ...businessDetail, industry: value })}>
                            {({ open }) => (
                                <>
                                    <div className="relative mt-2">
                                        <Listbox.Button className="relative w-full rounded-md input_focus_shadow bg-white py-2 pl-3 pr-7 text-left text-gray-900 focus:outline-none text-sm font-medium leading-6 h-[36px]">
                                            <div>{businessDetail.industry}</div>
                                            <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                                                <HiChevronUpDown className="text-[18px]" />
                                            </span>
                                        </Listbox.Button>

                                        <Transition
                                            show={open}
                                            as={Fragment}
                                            leave="transition ease-in duration-100"
                                            leaveFrom="opacity-100"
                                            leaveTo="opacity-0"
                                        >
                                            <Listbox.Options className="absolute sm:w-[400px] xs:w-[350px] w-[270px] z-[100] mt-1 max-h-60 overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 shadow-xl focus:outline-none text-sm">

                                                {Industry.map((person, i) => (
                                                    <>
                                                        <button onClick={() => handleIsopen(i)} key={i} className='text-sm hover:bg-[#f6f8fa] w-full items-center text-[#687385] flex justify-between p-[8px_12px]'>
                                                            {person.title}
                                                            <FiChevronDown className='text-[#687385]' />
                                                        </button>
                                                        {openId.includes(i) && person.industry.map((val, i) =>
                                                            <Listbox.Option
                                                                key={i}
                                                                className={({ active }) =>
                                                                    classNames(
                                                                        active
                                                                            ? "bg-[#f6f8fa]"
                                                                            : "text-[#414552]",
                                                                        "relative cursor-default select-none py-2 px-7"
                                                                    )
                                                                }
                                                                value={val}
                                                            >
                                                                {({ selected, active }) => (
                                                                    <>
                                                                        <div className='flex items-center justify-between'>
                                                                            <div className='flex gap-3 items-center'>
                                                                                <span
                                                                                    className={classNames(
                                                                                        selected
                                                                                            ? "font-semibold"
                                                                                            : "font-normal",
                                                                                        "block truncate"
                                                                                    )}
                                                                                >
                                                                                    {val}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {selected ? (
                                                                            <span
                                                                                className={classNames(
                                                                                    active
                                                                                        ? "text-white"
                                                                                        : "text-indigo-600",
                                                                                    "absolute inset-y-0 right-0 flex items-center pr-4"
                                                                                )}
                                                                            ></span>
                                                                        ) : null}
                                                                    </>
                                                                )}
                                                            </Listbox.Option>
                                                        )}
                                                    </>

                                                ))}
                                            </Listbox.Options>
                                        </Transition>
                                    </div>
                                </>
                            )}
                        </Listbox>
                    </div>

                    <div className='sm:mt-[40px] mt-[20px] group relative'>
                        <label htmlFor="Business-website" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Business website</label>
                        <div className="relative mt-1 w-full">
                            <input
                                value={businessDetail.business_website}
                                onChange={(e) => setBusinessDetail({ ...businessDetail, business_website: e.target.value })}
                                type='text' id="Business-website" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='www.example.com' />
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <p className='text-sm text-[#414552]'>If you don’t have a website, enter a social media page, LinkedIn, or other relevant link.</p>
                        </div>
                    </div>
                    <div className='sm:mt-[40px] mt-[20px] group relative'>
                        <label htmlFor="Product-description" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Product description</label>
                        <div className="relative mt-1 w-full">
                            <textarea
                                value={businessDetail.product_description}
                                onChange={(e) => setBusinessDetail({...businessDetail, product_description: e.target.value})}
                                id="Product-description" rows="3" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none py-1 text-[14px]"></textarea>
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <p className='text-sm text-[#414552]'>Provide a 1-2 sentence description. Make sure to note when you typically charge your customers (i.e. during checkout or 3 days later). This helps us better understand your business.</p>
                        </div>
                    </div>

                    <div className='mt-6 pb-5'>
                        <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Continue<BsArrowRightShort className='text-[25px]' /></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessDetails